const cacheBustUrl = (uri) => {
  if (typeof uri === 'string' && uri.startsWith('http')) {
    return uri + '?' + new Date().valueOf()
  }

  return uri
}

export { cacheBustUrl }
